<template>
  <div>
    <nav-bar></nav-bar>

    <div class="container-fluid">
      <slot />
    </div>

    <footer-bar></footer-bar>
  </div>
</template>

<script>
// '@' sign means src
import NavBar from '@/components/NavBar'
import FooterBar from '@/components/FooterBar'

export default {
  components: {
    NavBar,
    FooterBar
  }
}
</script>

<style scoped>

</style>
